import type {
	HookStateFunction,
	HookActionsFunction,
	BoundActions,
	Action,
} from 'react-sweet-state';

import {
	usePublishModalMountActions as usePublishModalMountStateActions,
	usePublishModalMountStore as usePublishModalMountStateStore,
} from '@confluence/publish-modal-state/entry-points/PublishModalMountState.ts';
import type {
	AutoFocusTargetOptions,
	PublishModalMountStateType,
	PublishModalSource as PublishModalStateSource,
} from '@confluence/publish-modal-state/entry-points/PublishModalMountState.ts';

export type PublishModalSource = PublishModalStateSource;

export const usePublishModalMountStore: HookStateFunction<PublishModalMountStateType, void> =
	usePublishModalMountStateStore;
export const usePublishModalMountActions: HookActionsFunction<
	BoundActions<
		PublishModalMountStateType,
		{
			openPublishModal: (
				modalSource?: PublishModalStateSource,
			) => Action<PublishModalMountStateType, void, void>;
			closePublishModal: () => Action<PublishModalMountStateType, void, void>;
			setInitialFocusTarget: (
				newFocusTarget: AutoFocusTargetOptions,
			) => Action<PublishModalMountStateType, void, void>;
		}
	>
> = usePublishModalMountStateActions;
